'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    class QuoteMediaTicker extends pageClass.PhoenixElement {
        connectedCallback() {
            super.connectedCallback();
            this.innerHTML = `
                <div class="m-quote-media-ticker--breadcrumbs-container">
                    ${this.config.sector ? `[ ${this.config.sector} ]` : ``}
                    ${this.config.industry ? `[ ${this.config.industry} ]` : ``}
                    ${this.config.fundCategory ? `[ ${this.config.fundCategory} ]` : ``}
                    [ ${this.config.symbol} ]
                </div>
                <div class="m-quote-media-ticker--content">
                    <div class="m-quote-media-ticker--headline">
                        <h1 class="m-quote-media-ticker--company-name">
                            ${this.config.title}
                        </h1>
                        <button class="m-button m-quote-media-ticker--button-follow">
                            <span> Follow </span>
                            <phoenix-icon-fallback class="m-svg" icon="ico_plus" aria-hidden="true">
                                <svg>
                                    <use xlink:href="/assets-global/icons/svg-sprite.svg#ico_plus">
                                    </use>
                                </svg>
                            </phoenix-icon-fallback>
                        </button>
                    </div>

                    <div class="m-quote-media-ticker--separator"> </div>
                    <div class="m-quote-media-ticker--ad-container">
                        <phoenix-ad
                            config='${JSON.stringify(this.config.ad[0])}'
                               class="m-quote-media-ticker--ad" style='width:${
                                   this.config.brokerSize.width
                               }px;height:${this.config.brokerSize.height}px;'></phoenix-ad>
                        <phoenix-ad
                            config='${JSON.stringify(this.config.ad[1])}'
                               class="m-quote-media-ticker--ad" style='width:${
                                   this.config.brokerSize.width
                               }px;height:${this.config.brokerSize.height}px;'></phoenix-ad>
                    </div>
                </div>
            `;
        }
    }

    window.customElements.define('phoenix-quote-media-ticker', QuoteMediaTicker);
});
